export const scrollToTop = () => {
  const authContent = document.getElementById('auth-content');
  authContent?.scrollTo({ top: 0, behavior: 'smooth' });
};

/**
 * Detect if the current page is running inside an iframe
 * @returns {boolean} true if running in iframe, false otherwise
 */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    // If we can't access window.top due to cross-origin restrictions,
    // we're definitely in an iframe
    return true;
  }
};

export const checkEmbedMode = (): boolean => {
  // 1. 优先检查 URL 参数 ?embed=true/false
  const urlParams = new URLSearchParams(window.location.search);
  const embedParam = urlParams.get('embed');

  if (embedParam !== null) {
    return embedParam === 'true';
  }

  // 2. 自动检测 iframe 环境
  return isInIframe();
};
